<template>
    <div class="wrapper">
        <div class="top">
            <div class="carousel">
                <!-- <slider animation="fade" height="100%" width="100%">
                    <slider-item class="carousel" v-for="(item, i) in bannerList" :key="i">
                        <a :href="item.url" target="_blank">
                            <img :src="`${item.image}@!cover.png`" alt="置顶项目">
                        </a>
                    </slider-item>
                </slider> -->
                <a :href="bannerList[0].url" target="_blank">
                            <img :src="`${bannerList[0].image}@!cover.png`" alt="置顶项目">
                        </a>
            </div>

            <div class="news">
                <ul>
                    <li>
                        <a href="https://www.sohu.com/a/647653113_121478296"
                            target="_blank">国际罕见病日：点亮“罕见”人生 上<span class="text-red">轻松筹</span>让爱不罕见</a>
                    </li>
                    <li>
                        <a href="https://baijiahao.baidu.com/s?id=1751637419470301948&wfr=spider&for=pc" target="_blank">以科技内驱力赋能全民公益，<span
                                class="text-red">轻松集团</span>荣获2022社会责任先锋企业奖</a>
                    </li>
                    <li>
                        <a href="http://www.cac.gov.cn/2020-06/17/c_1593959079203994.htm"
                            target="_blank">聚焦脱贫攻坚，中国互联网发展基金会联合中国SOS儿童村协会、<span class="text-red">轻松筹</span>等 开展“我想有个家”关爱儿童公益活动</a>
                    </li>
                    <!-- <li>
                        <a href="https://www.mca.gov.cn/article/xw/mtbd/202112/20211200038414.shtml" target="_blank">“123YI起来”<span
                                class="text-red">轻松筹</span>公益盛典传递向善正能量</a>
                    </li> -->
                    <li>
                        <a href="https://news.sina.com.cn/sx/2023-02-24/detail-imyhuqpt1672231.shtml" target="_blank">穿越风浪笃定向前，<span
                                class="text-red">轻松集团</span>荣获中国公益年会“2022年度公益企业”奖</a>
                    </li>
                    <li>
                        <a href="http://business.sohu.com/20181026/n553446690.shtml" target="_blank"><span
                                class="text-red">轻松公益</span>综合实力跻身前三 《2018互联网公开募捐平台综合实力TOP20》榜单发布</a>
                    </li>
                    <li>
                        <a href="http://finance.ifeng.com/a/20181105/16557631_0.shtml" target="_blank"><span
                                class="text-red">轻松筹</span>五大品牌全新升级 引领行业发展新风向</a>
                    </li>
                </ul>
            </div>
        </div>

        <div class="qsc-project-list">
            <div class="container" v-if="tabList && tabList.length">
                <div class="project-list_nav pinned">
                    <div class="subtab">
                        <div class="tab-item" v-bind:class="{ 'tab-item-active': index == checkindex }"
                            v-for="(item, index) in tabList" :key="index" @click="tabSelect(index, item)">
                            <span v-if="item && item.name"> {{ item.name || 'test' }}</span>
                            <span v-else> test </span>
                        </div>
                    </div>
                </div>

                <div class="row tab-content" v-if="viewProjectList && viewProjectList.length">
                    <div class="col-md-4" v-for="item in viewProjectList" :key="item.id">
                        <div class="mod-project-card" @click="toDetail(item)">
                            <div class="front-cover" >
                                <img v-if="item.front_cover" :src="`${item.front_cover}@!thumb.png`" width="100%">
                                <template v-else>
                                    <img v-if="item.cover" :src="`${item.cover[0].thumb}@!thumb.png`" width="100%" alt="项目图片">
                                </template>
                                <span>{{ tabList[checkindex].name }}</span>
                            </div>

                            <div class="summary">
                                <h4 v-if="item && item.name">{{ item.name || 'test' }}</h4>
                                <p>{{ item.detail }}</p>
                                <div class="list">
                                    <ul>
                                        <li><span>筹款目标</span><strong>{{ item.raisefunds_number }} <span>元</span></strong>
                                        </li>
                                        <li><span>已筹金额</span><strong>{{ item.accumulative_number }}
                                                <span>元</span></strong></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <template v-if="tabType === 'more'">
                    <div class="load_more" v-show="hasMore" @click="loadMore">查看更多</div>
                    <div v-if="!hasMore" class="no_more">暂无更多</div>
                </template>

            </div>


        </div>
    </div>
</template>

<script>
import axios from "axios"
import { Slider, SliderItem } from "vue-easy-slider"
export default {
  data() {
    return {
      donateInfo: null,
      projectList: [],
      viewProjectList: [],
      tabList: [],
      bannerList: [],
      checkindex: 0,
      sucProjectList: [],
      page: 1, //分页索引
      hasMore: true,
      tabType: "",
    }
  },
  components: {
    Slider,
    SliderItem,
  },
  methods: {
    getBanner() {
      //   axios
      //     .get("https://partner-gateway.qschou.com/official/v1/home/banner")
      //     .then((res) => {
      //       res = res.data
      //       if (res.code === 0) {
      //         this.bannerList = res.data
      //       }
      //     })
      this.bannerList = [
        {
          id: 109,
          image:
            "https://images-partner.qschou.com/files/banner/PbWhsQnERkZsiWGeFywmjWhj22NQx4Cb.jpg",
          url: "https://mp.weixin.qq.com/s/Tb4AzgTJi5aDT3kcYW1mdQ",
          weight: 127,
          site: "",
          active: 1,
        },
      ]
    },
    getList() {
      //   axios
      //     .get("https://partner-gateway.qschou.com/official/events")
      //     .then((res) => {
      //       res = res.data
      //       if (res.code === 0) {
      //         let tabList = []
      //         let projectList = []
      //         let list = res.data.list

      //         for (let index = 0; index < list.length; index++) {
      //           if (list[index].projects !== null) {
      //             // this.tabList[index] = res.data.list[index];
      //             // this.$set(this.tabList, index, res.data.list[index]);
      //             tabList.push(list[index])
      //             projectList.push(list[index].projects)
      //           }
      //         }
      //         // console.log(tabList, 'tabList')
      //         // console.log(projectList, 'projectList')
      //         // this.projectList = this.tabList[index].projects;
      //         // tabList.push({
      //         //   name: "筹款中",
      //         //   type: "more",
      //         // })
      //         this.tabList = tabList
      //         this.projectList = projectList
      //         this.viewProjectList = projectList[0]
      //       }
      //     })
      //     .catch((error) => {
      //       if (error.status === 401) {
      //         document.querySelector(".mask-authority").style.display = "block"
      //       }
      //     })
      this.tabList = [
        {
          id: 9,
          name: "今日关注",
        },
      ]

      this.viewProjectList = [
        {
          site_channel: "wagyjjh",
          site_is_public: true,
          project_no: "202304200000000128674107",
          address: "",
          name: "微爱圆梦助学计划，助力寒门学子",
          summary: "乡村教育事业的发展，是乡村振兴战略的重要支点。为支...",
          detail: "乡村教育事业的发展，是乡村振兴战略的重要支点。为支...",
          progress: "0.88",
          raisefunds_number: "5106382",
          accumulative_number: "45084",
          cover: [
            {
              thumb:
                "https://images-partner.qschou.com/wagyjjh/files/project/70467751b074d8e139c48616c2b8cc356677b762h5.jpg",
            },
          ],
          monthly_donation: 1,
        },
        {
          site_channel: "wagyjjh",
          site_is_public: true,
          project_no: "201809130000000021922217",
          address: "",
          name: "帮助那些在病房里渴望知识的孩子们",
          summary: "有这样一群孩子，他们热爱生活，对未来充满着期待，他...",
          detail: "有这样一群孩子，他们热爱生活，对未来充满着期待，他...",
          progress: "59.36",
          raisefunds_number: "1000000",
          accumulative_number: "593554",
          cover: [
            {
              thumb:
                "https://images-partner.qschou.com/wagyjjh/files/project/57650616d7e5472ffd84f7aaeb5bfda97a872668h5.jpg",
            },
          ],
          monthly_donation: 1,
        },
        {
          site_channel: "wagyjjh",
          site_is_public: true,
          project_no: "202103110000000094740630",
          address: "",
          name: "一起做白衣战士守护神",
          summary: "2019年的冬天，他们用自己的身躯挡住病毒，做过那...",
          detail: "2019年的冬天，他们用自己的身躯挡住病毒，做过那...",
          progress: "53.69",
          raisefunds_number: "1000000",
          accumulative_number: "536898",
          cover: [
            {
              thumb:
                "https://images-partner.qschou.com/wagyjjh/files/project/58042094ab1e15a7df850a92a9e55a414fbc78cdh5.jpg",
            },
          ],
          monthly_donation: 0,
        },
      ]
    },

    toDetail(item) {
      //   let queryInfo = {
      //     ChannelId: item.site_channel,
      //     id: item.project_no,
      //   }
      //   if (this.tabType === "more") {
      //     queryInfo = {
      //       ChannelId: item.channel,
      //       id: item.raisefund_no,
      //     }
      //   }
      //   this.$router.push({
      //     path: "/detail",
      //     query: queryInfo,
      //   })
    },

    getSuccessProject() {
      let page = this.page
      axios
        .get("https://partner-gateway.qschou.com/official/pc/project/doing", {
          params: {
            page,
          },
        })
        .then((res) => {
          let info = res.data
          if (info.code === 0) {
            this.page++
            if (info.data.length < 20) {
              this.hasMore = false
            }
            if (this.tabType === "more") {
              let viewProjectList = this.viewProjectList
              if (info.data.length) {
                viewProjectList.push(...info.data)
              }
              this.viewProjectList = viewProjectList
            } else {
              this.sucProjectList = info.data
            }
          }
        })
    },

    loadMore() {
      //   this.getSuccessProject()
    },

    tabSelect(index, item) {
      //   this.checkindex = index
      //   if (item.type === "more") {
      //     this.viewProjectList = this.sucProjectList
      //     this.tabType = item.type
      //     return
      //   }
      //   this.tabType = ""
      //   this.viewProjectList = this.projectList[index]
    },
  },
  created() {
    // this.getSuccessProject()
    this.getList(0)
    this.getBanner()
  },
}
</script>

<style lang="less" scoped>
a {
  text-decoration: none;
}

.wrapper {
  background: #f7f9fa;
}

.top {
  display: flex;
  justify-content: flex-start;
  width: 1190px;
  margin: 0 auto;
  padding-left: 10px;
  padding-top: 25px;

  .carousel {
    width: 690px;
    height: 260px;

    .slider {
      display: inline-block;
      border-radius: 4px;
      box-shadow: 0 5px 20px rgba(0, 0, 0, 0.3);
    }
  }

  .news {
    height: 260px;
    text-align: left;
    overflow: hidden;

    ul {
      margin: 0;
      padding-left: 30px;
      color: #d13c3c;

      li {
        line-height: 38px;

        a {
          display: block;
          width: 450px;
          font-size: 14px;
          color: #2b3845;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;

          &:hover {
            .text-red {
              font-weight: 500;
              color: #d13c3c;
              border-bottom: 2px solid #d13c3c;
            }
          }
        }
      }
    }
  }
}

.qsc-project-list {
  position: relative;
  font-size: 14px;
  color: #2b3845;

  // min-height: 50vh;
  .container {
    width: 1200px;
    margin-right: auto;
    margin-left: auto;

    .project-list_nav {
      position: relative;
      display: flex;
      padding: 20px 0;

      .subtab {
        margin: 8px 0;
        text-align: center;
        padding: 0;

        .tab-item {
          cursor: pointer;
          display: inline-block;
          margin: 0 8px;
          padding: 6px 14px;
          color: #6f7a7e;
          font-size: 14px;
          border-radius: 50px;
        }

        .tab-item-active {
          background-color: #d13c3c;
          color: #fff;
          font-weight: 600;
        }
      }
    }

    .tab-content {
      display: flex;
      flex-wrap: wrap;
      padding-bottom: 40px;

      .notice {
        position: absolute;
        bottom: 20px;
        left: 0;
        right: 0;
        margin: 0 auto;
        line-height: 2;
        letter-spacing: 2px;
        color: #999;

        span {
          font-weight: 500;
        }
      }

      .col-md-4 {
        width: 23%;
        position: relative;
        min-height: 1px;
        padding: 0 10px;

        .mod-project-card {
          background: #fff;
          position: relative;
          margin-bottom: 30px;
          border-radius: 3px;
          box-shadow: 0 5px 20px hsla(0, 0%, 85%, 0.5);
          transition: all 0.3s linear;

          &:hover {
            box-shadow: 0 5px 20px rgba(0, 0, 0, 0.3);
          }

          .front-cover {
            height: 210px;

            span {
              position: absolute;
              top: 15px;
              right: 15px;
              z-index: 5;
              border: 1px solid #fff;
              color: #fff;
              padding: 1px 6px;
              border-radius: 10px;
              font-size: 12px;
              font-weight: 600;
              background-color: rgba(0, 0, 0, 0.2);
            }

            img {
              height: 100%;
              width: 100%;
            }
          }

          .summary {
            padding: 15px;

            h4 {
              margin: 0;
              font-size: 17px;
              font-weight: 400;
              text-align: left;
              height: 48px;
              overflow: hidden;
              color: #333;
            }

            .list {
              text-align: left;
              position: relative;

              ul {
                margin: 0;
                padding: 0;
                list-style: none;

                li {
                  height: 32px;
                  line-height: 32px;
                  background: url("data:image/gif;base64,R0lGODlhAwABAJEAAP////f399vb2wAAACH5BAAHAP8ALAAAAAADAAEAAAICjFAAOw==")
                    repeat-x left center;

                  span {
                    background: #fff;
                    color: #6f7a7e;
                    padding-right: 8px;
                  }

                  strong {
                    background: #fff;
                    float: right;
                    padding-left: 8px;
                    padding-right: 0;
                    color: #ed2424;
                    font-weight: 500;
                  }
                }
              }
            }

            p {
              font-size: 13px;
              color: #999;
              text-align: left;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              margin: 6px 0 12px 0;
            }
          }
        }
      }
    }

    //加载更多
    .load_more {
      cursor: pointer;
      border: 1px solid #d13c3c;
      border-radius: 6px;
      width: 120px;
      padding: 5px 0;
      margin: 20px auto 50px;
      font-size: 18px;
      font-weight: 500;
      color: #d13c3c;
      box-shadow: 0 5px 10px hsla(0, 0%, 85%, 0.5);
      transition: all 0.3s linear;
      &:hover {
        box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
      }
    }
    .no_more {
      border: 1px solid #999;
      border-radius: 6px;
      width: 120px;
      padding: 5px 0;
      margin: 20px auto 0;
      font-size: 18px;
      font-weight: 500;
      color: #999;
    }
  }
}

.mod-project-card,
.mod-project-card,
.qsc-project-list .mod-project-card {
  overflow: hidden;
}
</style>
